<template>
<div class="chapter">
<div class="inner_page">
<p class="epi"><i>“Would you believe that I don’t like to think</i></p>
<p class="inset"><i>back on those times, primarily</i></p>
<p class="inset"><i>because then I feel really sad, </i></p>
<p class="inset"><i>really feel it, deep down?”</i></p>
<p class="tx"> </p>
<p class="inset"><i>How can I answer her, who answered me</i></p>
<p class="inset"><i>So many ways,</i></p>
<p class="inset"><i>Whom now the same precocious spring betrays?</i></p>
<p class="inset"><i>Say that time passes only to return?</i></p>
<p class="inset"><i>Or utter that belated fiction that </i></p>
<p class="inset"><i>Time saddens, true, but also makes us wise?</i></p>
<p class="tx"> </p>
<p class="inset">—Wayne Brown, “A Letter from Elizabeth,” </p>
<p class="inset"><i>On the Coast and Other Poems</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?5e6e7c06